import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.4689 9.08327L13.3125 7.9269C12.9706 7.58433 12.515 7.39583 12.0305 7.39583H8.60427V6.1875H12.5314C13.3639 6.1875 14.0418 5.50962 14.0418 4.67708V3.46875C14.0418 2.63621 13.3639 1.95833 12.5314 1.95833H8.60065L8.60427 1.35779C8.60608 1.02369 8.33723 0.751813 8.00313 0.75H8.0001C7.66781 0.75 7.39775 1.01825 7.39594 1.35054L7.39231 1.95833H3.9691C3.48517 1.95833 3.02963 2.14683 2.68706 2.4894L1.53069 3.64577C1.29446 3.882 1.29446 4.26383 1.53069 4.50006L2.68706 5.65644C3.02902 5.999 3.48456 6.1875 3.9691 6.1875H7.39533V7.39583H3.46825C2.63571 7.39583 1.95783 8.07371 1.95783 8.90625V10.1146C1.95783 10.9471 2.63571 11.625 3.46825 11.625H7.3899L7.39533 14.647C7.39533 14.9805 7.6666 15.25 7.9995 15.25H8.00071C8.33421 15.25 8.60427 14.9781 8.60367 14.6446L8.59823 11.625H12.0305C12.5144 11.625 12.97 11.4365 13.3125 11.0939L14.4689 9.93756C14.7051 9.70133 14.7051 9.3195 14.4689 9.08327ZM3.54196 4.80215L2.81273 4.07292L3.54196 3.34369C3.65615 3.2295 3.80779 3.16667 3.96971 3.16667H12.5314C12.6981 3.16667 12.8334 3.302 12.8334 3.46875V4.67708C12.8334 4.84383 12.6981 4.97917 12.5314 4.97917H3.96971C3.8084 4.97917 3.65615 4.91633 3.54196 4.80215ZM12.4583 10.2396C12.3441 10.3538 12.1924 10.4167 12.0305 10.4167H3.46885C3.3021 10.4167 3.16677 10.2813 3.16677 10.1146V8.90625C3.16677 8.7395 3.3021 8.60417 3.46885 8.60417H12.0305C12.1918 8.60417 12.3441 8.667 12.4583 8.78119L13.1875 9.51042L12.4583 10.2396Z"
      fill="#151718"
    />
  </svg>
);

const NeedHelp = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default NeedHelp;
